import intl from 'react-intl-universal';
import { SelectBox } from 'components/uikit-adapter';
import {
  ModalText,
  ModalTitle,
  WrapperButtons,
  WrapperContent,
} from './styled';
import { IJustification } from 'types/justification';
import { useToastContext } from 'hooks/useToastContext';
import GenericModal from 'components/generic-modal';
import Button from 'components/button';

interface ILoadBuildingJustificationModalProps {
  open: boolean;
  handleConfirm: (key?: number) => void;
  handleClose: () => void;
  justifications: Array<IJustification>;
  justification: number;
  handleChangeJustification: (field: string, value: number) => void
}

const LoadBuildingJustificationModal = ({
  open,
  handleConfirm,
  handleClose,
  justifications,
  justification,
  handleChangeJustification
}: ILoadBuildingJustificationModalProps) => {
  const { openToast } = useToastContext();

  const handleSelectChange = (value: IJustification) => {
    handleChangeJustification('TypeJustificationManualSuggestion', value.Key);
  };

  const handleConfirmButton = () => {
    if(!justification){
      openToast(intl.get('load-building.page-flow.modal-justification.youMustProvideAJustificationToProceed'), 'negative');
    } else {
      handleConfirm(justification);
      handleClose();
    } 
  }

  return (
    <GenericModal
      open={open}
      onRequestClose={handleClose}
    >
      <WrapperContent>
        <ModalTitle>
          {intl.get('load-building.page-flow.modal-justification.title')}
        </ModalTitle>

        <ModalText>
          {intl.get('load-building.page-flow.modal-justification.message')}
        </ModalText>
        <SelectBox
          required
          name='justifications'
          className='justifications-selectbox'
          valueKey='Key'
          labelKey='Value'
          value={justification}
          options={justifications}
          onChange={(value: IJustification) => handleSelectChange(value)}
          openOnFocus
          placeholder={intl.get(
            'load-building.page-flow.modal-justification.placeholder'
          )}
          disabled={undefined}
          data-testid="selectbox-justification"
        />
      </WrapperContent>
      <WrapperButtons>
        <Button
          buttonType='tertiary'
          value={intl.get('geral.buttonsDefault.cancel')}
          onClick={handleClose}
          className='btn'
          style={{ width: '150px' }}
        />
        <Button
          buttonType='primary'
          value={intl.get('geral.buttonsDefault.confirm')}
          onClick={handleConfirmButton}
          className='btn margin-botao'
          style={{ width: '150px' }}
        />
      </WrapperButtons>
    </GenericModal>
  );
};

export default LoadBuildingJustificationModal;
